import formatFileSize from './utils'

const messages = {
  _default: () => `hodnota je neplatná.`,
  after: (field, [target, inclusion]) =>
    `musí byť po ${inclusion ? 'alebo rovné ' : ''}${target}.`,
  alpha_dash: () =>
    `pole smie obsahovať alfanumerické znak, pomlčky a podčiarkovník.`,
  alpha_num: () =>
    `pole smie obsahovať iba alfanumerické znaky.`,
  alpha_spaces: () =>
    `pole smie obsahovať alfabetické znaky a medzery.`,
  alpha: () => `pole smie obsahovať iba abecedné znaky.`,
  before: (field, [target, inclusion]) =>
    `musí byť pred ${inclusion ? 'alebo sa rovná' : ''}${target}.`,
  between: (field, [min, max]) =>
    `pole musí byť medzi ${min} a ${max}.`,
  confirmed: () => `potvrdenie sa nezhoduje.`,
  credit_card: () => `pole je neplatné.`,
  date_between: (field, [min, max]) =>
    `musí byť medzi ${min} a ${max}.`,
  date_format: (field, [format]) =>
    `musí byť vo formáte ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `pole musí byť numerické a smie obsahovať ${
      !decimals || decimals === '*' ? '' : decimals
    } desatinných miest.`,
  digits: (field, [length]) =>
    `pole musí byť numerické a obsahovať presne ${length} číslic.`,
  dimensions: (field, [width, height]) =>
    `pole musí mať ${width} pixelov na ${height} pixelov.`,
  email: () => `pole musí obsahovať platný email.`,
  ext: () => `pole musí obsahovať správny súbor.`,
  image: () => `pole musí obsahovať obrázok.`,
  in: () => `pole musí obsahovať platnú hodnotu.`,
  integer: () => `pole musí obsahovať celé číslo.`,
  ip: () => `pole musí obsahovať platnú IP adresu.`,
  length: (field, [length, max]) => {
    if (max) {
      return `dĺžka musí byť medzi ${length} a ${max}.`
    }

    return `dĺžka musí byť ${length}.`
  },
  max: (field, [length]) =>
    `pole nesmie byť dlhšie ako ${length} znakov.`,
  max_value: (field, [max]) => `pole musí byť ${max} alebo menej.`,
  mimes: () => `pole musí obsahovať platný súborový typ.`,
  min: (field, [length]) =>
    `pole musí obsahovať aspoňt ${length} znakov.`,
  min_value: (field, [min]) => `pole musí byť ${min} alebo viac.`,
  not_in: () => `pole musí obsahovať platnú hodnotu.`,
  numeric: () => `pole smie obsahovať iba čísla.`,
  regex: () => `formát poľa je neplatný.`,
  required: () => `pole je povinné.`,
  size: (field, [size]) =>
    `veľkosť musí byť ${formatFileSize(size)}.`,
  url: () => `pole neobsahuje platné URL.`,
  fullName: () => 'nie je platné (meno, krsné meno a max 120 znakov)',
  emailInput: () => 'pole musí obsahovať platný email.',
  fullNamePerCountry: () => 'nie je platné (meno, krsné meno a max 18 znakov)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'sk',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/sk.js